import {GET_VAT_SUCCESS} from "../actions/settings";

export default function(state = {vat: null}, action) {
    switch (action.type) {
        case GET_VAT_SUCCESS:
            return { ...state, vat: action.payload.results };
        default:
            return state;
    }
}



// WEBPACK FOOTER //
// ./src/store/reducers/settings.js